import { defineSlotRecipe } from "shared/components/Spor";

export const moduleRecipe = defineSlotRecipe({
  className: "drops-module",
  slots: ["root", "header", "body"],
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      minH: "0",
      minW: "400px",
      borderRadius: "6px",
      border: "1px solid",
      borderColor: "outline.disabled",
    },
    header: {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      gap: "2",
      flexShrink: "0",
    },
    body: {
      display: "flex",
      flexDirection: "column",
      flex: "1",
      minH: "0",
    },
  },
  variants: {
    size: {
      md: {
        root: { textStyle: "md", backgroundColor: "bg.brand" },
        header: {
          paddingBlock: "12px",
          paddingInline: "12px",
          backgroundColor: "bg.brand",
        },
        body: {
          paddingInline: "12px",
          paddingBottom: "12px",
          paddingTop: "12px",
        },
      },
      lg: {
        root: { textStyle: "lg", backgroundColor: "bg.subtle" },
        header: {
          gap: "3",
          paddingBlock: "18px",
          paddingInline: "18px",
          backgroundColor: "bg.subtle",
        },
        body: {
          textStyle: "md",
          fontWeight: "normal",
          paddingInline: "18px",
          paddingBottom: "18px",
          paddingTop: "0",
        },
      },
    },
    // Disables the left AND right (inline) padding on the body (e.g. the Trasé
    // module whose table spans edge-to-edge). The header keeps its padding.
    disablePadding: {
      true: {
        body: { paddingInline: "0" },
      },
      false: {},
    },
    // NOTE: these keys must match the `Semantics` union Module passes in.
    // Left as no-op overrides for now — add per-semantic slot styles as needed.
    semantic: {
      neutral: {},
      info: {},
      success: {},
      warning: {},
      alarm: {},
    },
  },
  defaultVariants: {
    size: "md",
    disablePadding: false,
  },
});
